var _style, _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdcPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 86 78",
    style: {
      enableBackground: "new 0 0 86 78"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;opacity:0.2;}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st4{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st5{fill:#000000;}\r\n\t.st6{fill:#000000;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st7{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st8{fill:#000000;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;}\r\n\t.st9{display:inline;}\r\n\t.st10{fill:none;stroke:#C9C9C9;stroke-width:0.1;stroke-miterlimit:10;}\r\n\t.st11{fill:none;stroke:#C9C9C9;stroke-width:0.071;stroke-miterlimit:10;}\r\n\t.st12{fill:none;stroke:#C9C9C9;stroke-width:0.0707;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Base_tile"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_878_",
    className: "st5",
    d: "M48.0785,44.4005l-0.7444-1.3303c-0.0933-0.1667-0.3058-0.2271-0.4747-0.1351l-2.7567,1.503 V41.331c0-0.1903-0.1564-0.3446-0.3493-0.3446h-1.5399c-0.1929,0-0.3493,0.1543-0.3493,0.3446v3.0677l-2.6923-1.5329 c-0.1671-0.0951-0.3806-0.0386-0.4771,0.1262l-0.77,1.3162c-0.0964,0.1649-0.0392,0.3757,0.1279,0.4708l3.1079,1.7695 l-2.5372,2.5031c-0.1364,0.1346-0.1364,0.3528,0,0.4874l1.0887,1.0742c0.1364,0.1346,0.3575,0.1346,0.4939,0l2.7775-2.7402 l2.7771,2.7402c0.1364,0.1346,0.3576,0.1346,0.494,0l1.0887-1.0742c0.1364-0.1346,0.1364-0.3528,0-0.4874l-2.5176-2.4841 l3.1158-1.6987C48.1104,44.7767,48.1717,44.5671,48.0785,44.4005z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M54.2433,34.5625h-2.2487V29.932c0-4.7881-3.8407-8.682-8.5629-8.682c-4.7986,0-8.5606,3.6787-8.5606,8.3713 c0,0.8365-0.009,2.1078-0.018,3.3104l-0.0067,1.6308h-3.0897c-1.239,0-2.2487,0.9962-2.2487,2.2188v17.75 c0,1.2225,1.0096,2.2188,2.2487,2.2188h22.4866c1.239,0,2.2487-0.9962,2.2487-2.2188v-17.75 C56.4919,35.5587,55.4823,34.5625,54.2433,34.5625 M37.1018,32.9473c0.009-1.2092,0.018-2.485,0.018-3.3259 c0-3.4502,2.7726-6.1526,6.312-6.1526c3.4832,0,6.3142,2.8999,6.3142,6.4632v4.6305H37.095L37.1018,32.9473z M54.2433,55.6406 v-1.1094H31.7567v-17.75h22.4866v17.75h0.0022L54.2433,55.6406z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_8"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Guide2",
    className: "st0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdcPassword);
export default __webpack_public_path__ + "static/media/ADC_Password.f132d23663aa906469ae1f94feb23699.svg";
export { ForwardRef as ReactComponent };